<ng-container *ngIf="vm$ | async as vm; else loadingTemplate">
  <div mat-dialog-title>
    <mode-dialog-header>
      <h1 heading class="heading">
        {{ headerText }}
      </h1>
      <div sub-heading *ngIf="vm.userConnected">
        <h5 class="account">
          <span class="account-label">Account:</span>
          {{ vm.email }}
          <a class="account-link link" [href]="vm.accountUrl" rel="noopener noreferrer" target="_blank"> Manage </a>
        </h5>
      </div>
    </mode-dialog-header>
    <nav mat-tab-nav-bar *ngIf="vm.userConnected">
      <a
        mat-tab-link
        data-test="google-sheets-tab"
        *ngFor="let tab of tabs; trackBy: tabTrackByFn"
        [active]="form.activeTab === tab"
        (click)="form.selectTab(tab)"
      >
        {{ tab }}
      </a>
    </nav>
  </div>

  <ng-container *ngIf="vm.userConnected; else notConnectedTemplate">
    <div mat-dialog-content>
      <form id="upload-sheet-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <ng-container *ngIf="form.activeTab === 'Search'">
          <mode-sheets-browser
            [spreadsheets]="vm.spreadsheets"
            [worksheets]="vm.worksheets"
            [searchText]="form.searchText.value"
            [moreSheetsAvailable]="vm.showLoadMore"
            [helpLink]="helpLink"
            (spreadsheetChange)="form.selectSpreadsheet($event)"
            (worksheetChange)="form.selectWorksheet($event)"
            (searchTextChange)="form.search($event)"
            (loadMoreSheets)="loadMore()"
          ></mode-sheets-browser>
        </ng-container>

        <ng-container *ngIf="form.activeTab === 'By URL'">
          <div class="browser-top">
            <p class="browser-header mode-label">Google Sheet</p>
            <a class="browser-link"
              [href]="helpLink"
              target="_blank"
            >
              Learn how to prep your Sheet data
            </a>
          </div>
          <div class="browser">
            <input
              data-test="google-sheets-url-input"
              class="mode-input"
              [class.mode-input-error]="form.urlError"
              type="text"
              formControlName="url"
              placeholder="Paste a Google Sheet URL here, like https://docs.google.com/spreadsheets/abc123"
              capraAutofocus
            />
            <p *ngIf="form.urlError" class="mode-validation-error">
              Please enter a valid Google Sheet URL, like docs.google.com/spreadsheets/abc123
            </p>

            <div class="url-cta">
              <h2 class="url-cta-text">To get started, paste a Google Sheet URL above</h2>
              <capra-icon class="url-cta-icon" icon="illo-dataset-url" width="72px" height="72px"></capra-icon>
            </div>
          </div>
        </ng-container>

        <div class="dataset">
          <label class="mode-label" for="dataset-name"> Dataset name </label>
          <input
            id="dataset-name"
            class="mode-input"
            [class.mode-input-error]="form.nameError"
            formControlName="name"
            (blur)="onNameBlur()"
          />
          <p *ngIf="form.nameError" class="mode-validation-error">Name must be 4 - 64 characters long</p>

          <label class="mode-label" for="dataset-description">
            Dataset description
            <span class="addendum"> (used in place of thumbnails in Collection views) </span>
          </label>
          <input class="mode-input" id="dataset-description" formControlName="description" />
        </div>

        <mode-status-banner status="info" [showIcon]="false">
          <span class="banner-note">{{ vm.spreadsheetName }}</span> will be added to your
          <span class="banner-note">Personal content</span> and will be usable by anyone with
          <span class="banner-note">view access to your Personal content.</span> Column names will be auto-generated
          from the first row.
        </mode-status-banner>
      </form>
    </div>

    <div mat-dialog-actions class="actions">
      <capra-button
        class="action"
        text="Cancel"
        variant="secondary"
        color="neutral"
        (clicked)="dialogRef.close()"
      ></capra-button>
      <capra-button
        class="action"
        form="upload-sheet-form"
        type="submit"
        text="Create Dataset"
        [disabled]="!form.valid"
      ></capra-button>
    </div>
  </ng-container>

  <ng-template #notConnectedTemplate>
    <mode-account-connection-cta
      class="account-connection-cta"
      mat-dialog-content
      [link]="vm.accountUrl"
    ></mode-account-connection-cta>
  </ng-template>
</ng-container>

<ng-template #loadingTemplate>
  <div mat-dialog-title>
    <mode-dialog-header>
      <h1 heading class="heading">
        {{ headerText }}
      </h1>
    </mode-dialog-header>
  </div>
  <mode-loader class="loader" type="tertiary"> </mode-loader>
</ng-template>
